import axios from 'axios'
import decode from 'jwt-decode'
import Cookies from 'js-cookie'

const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'

const TOKEN_KEY = '_mocoadm'
const TOKEN_HEADER_KEY = 'x-authorization'

const API_URL = process.env.API_URL

const state = {
  user: null,
  token: null,
  tokenHeaderKey: TOKEN_HEADER_KEY
}

const getters = {
  authenticated: state => {
    return !!state.user
  },
  userId: state => state.user && state.user.uid
}

function commitWhenValid (token, commit) {
  if (token) {
    try {
      let payload = decode(token)
      if (payload.role !== 'admin') {
        return false
      }
      commit(LOGIN, { payload: payload, token: token })
      return true
    } catch (error) {
      console.error('JWT token malformed.')
      return false
    }
  }
  return false
}

const actions = {
  autologin ({ commit }) {
    return new Promise((resolve, reject) => {
      const token = Cookies.get(TOKEN_KEY)
      commitWhenValid(token, commit) ? resolve() : reject()
    })
  },
  login ({ commit, rootState }, { email, password }) {
    return new Promise((resolve, reject) => {
      axios.post(API_URL + '/auth/login', {
        usr: email,
        pwd: password
      })
      .then(response => {
        const token = response.headers[TOKEN_HEADER_KEY]
        if (commitWhenValid(token, commit)) {
          Cookies.set(TOKEN_KEY, token)
          resolve()
        } else {
          reject()
        }
      })
      .catch(err => {
        reject(err.response)
      })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve) => {
      Cookies.remove(TOKEN_KEY)
      commit(LOGOUT)
      resolve()
    })
  }
}

const mutations = {
  [LOGIN] (state, { payload, token }) {
    state.user = payload
    state.token = token
  },
  [LOGOUT] (state) {
    state.user = null
    state.token = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js